module.exports = __webpack_public_path__ + "img/modulo_Space.b3cd3ed.svg";